import moment from 'moment-timezone'
import { Grid } from '@mui/material'
import Header from '../../../../../Header'

import { getEndOfBillingPeriodView } from '../../../../../../formatting/billingPeriod'
import { formatDateWithoutTimezone } from '../../../../../../formatting'

function BillingPeriodHeader({ firstDay, lastDay }) {
    return (
        <Grid container sx={{ marginTop: '25px' }}>
            <Grid item xs={12} sx={{ fontSize: '24px' }}>
                <Header title={`Billing Period ${moment(Date.parse(firstDay)).format('M/DD')} - ${formatDateWithoutTimezone(getEndOfBillingPeriodView(lastDay))}`} />
            </Grid>
        </Grid>
    )
}

BillingPeriodHeader.propTypes = {
}

export default BillingPeriodHeader
